/**
 * What this file does:
 * It's a helper "component" to render AI sections based on the page mode
 * i.e live view mode or live edit mode
 */
import React from 'react';

import { useEditorToolbar } from '@atlaskit/editor-common/toolbar/context';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import type { SeparatorPosition } from '@atlaskit/editor-toolbar/toolbar-section';
import { ToolbarSection } from '@atlaskit/editor-toolbar/toolbar-section';

import type { AIPlugin } from '../../../aiPluginType';

const usePluginState = (_api?: ExtractInjectionAPI<AIPlugin> | undefined) => {
	const { editorViewMode } = useEditorToolbar();

	return {
		editorViewMode,
	};
};

export const AISection = ({
	api,
	children,
	hasSeparator,
}: {
	api: ExtractInjectionAPI<AIPlugin> | undefined;
	children: React.ReactNode;
	hasSeparator?: SeparatorPosition;
}): React.JSX.Element | null => {
	const { editorViewMode } = usePluginState(api);
	const isEdit = editorViewMode === 'edit' || editorViewMode === undefined;

	if (!isEdit) {
		return null;
	}

	return <ToolbarSection hasSeparator={hasSeparator}>{children}</ToolbarSection>;
};

export const AIViewSection = ({
	api,
	children,
	hasSeparator,
}: {
	api: ExtractInjectionAPI<AIPlugin> | undefined;
	children: React.ReactNode;
	hasSeparator?: SeparatorPosition;
}): React.JSX.Element | null => {
	const { editorViewMode } = usePluginState(api);
	const isView = editorViewMode === 'view';

	if (!isView) {
		return null;
	}

	return <ToolbarSection hasSeparator={hasSeparator}>{children}</ToolbarSection>;
};
